import {
  AlignmentType,
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  TextRun,
  LineRuleType,
  ImageRun,
  Header,
  TextWrappingType,
  TextWrappingSide,
  VerticalPositionAlign,
  HorizontalPositionAlign,
  Footer,
  LevelFormat,
  convertInchesToTwip,
} from "docx";
import dateFormat, { i18n } from "dateformat";

const DAYS_SPANISH = [
  "Dom",
  "Lun",
  "Mar",
  "Mie",
  "Jue",
  "Vie",
  "Sab",
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

i18n.dayNames = DAYS_SPANISH;

i18n.monthNames = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const regexDeleteHtmlTags = /(<([^>]+?)>)/gi;

const sizeText = 22;

const colorTitle = "#00374F";

const colorBody = "#393B53";

const configDocument = [
  {
    reference: "decimalNumbering",
    levels: [
      {
        level: 0,
        text: "",
        format: LevelFormat.DECIMAL,
        alignment: AlignmentType.START,
        style: {
          run: {
            size: sizeText,
          },
          paragraph: {
            indent: {
              left: convertInchesToTwip(0),
              hanging: convertInchesToTwip(0),
            },
          },
        },
      },
      {
        level: 1,
        text: "",
        format: LevelFormat.DECIMAL,
        alignment: AlignmentType.START,
        style: {
          run: {
            size: sizeText,
          },
          paragraph: {
            indent: {
              left: convertInchesToTwip(0.5),
              hanging: convertInchesToTwip(0.25),
            },
          },
        },
      },
      {
        level: 2,
        text: "",
        format: LevelFormat.DECIMAL,
        alignment: AlignmentType.START,
        style: {
          run: {
            size: sizeText,
          },
          paragraph: {
            indent: {
              left: convertInchesToTwip(1),
              hanging: convertInchesToTwip(0.5),
            },
          },
        },
      },
      {
        level: 3,
        text: "%1.",
        format: LevelFormat.NONE,
        alignment: AlignmentType.START,
        style: {
          run: {
            size: sizeText,
          },
          paragraph: {
            indent: {
              left: convertInchesToTwip(1),
              hanging: convertInchesToTwip(0),
            },
          },
        },
      },
    ],
  },
];

const DocStyles = {
  default: {
    document: {
      run: {
        font: "Roboto",
      },
    },
  },
  paragraphStyles: [
    {
      id: "paragraphMilestone",
      name: "body Content",
      paragraph: {
        alignment: AlignmentType.JUSTIFIED,
        spacing: {
          line: 275.8,
          lineRule: LineRuleType.AUTO,
        },
      },
    },
  ],
};

export const reportMilestoneCreator = ({
  title = "Informe de hitos",
  reports,
  contract = "",
}) => {
  const document = new Document({
    numbering: { config: configDocument },
    title,
    creator: "Legal AI",
    styles: DocStyles,
    sections: [
      {
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [imageHeaderOne],
              }),
              new Paragraph({
                children: [imageHeaderTwo],
              }),
            ],
          }),
        },
        children: [
          new Paragraph({
            children: [image],
          }),
          breakLine(),
          docTitle("Informe de Hitos y Fechas"),
          breakLine(),
          docTitle(contract, 0),
          breakLine(),
          ...reportsList(reports),
        ],
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.END,
                children: [new TextRun(dateFormat(new Date(), "mediumDate"))],
              }),
            ],
          }),
        },
      },
    ],
  });
  const file = Packer.toBlob(document).then((documentBlob) => documentBlob);
  return file;
};

export const reportValuesCreator = ({
  title = "Informe de valores",
  reports,
  contract = "",
}) => {
  const document = new Document({
    numbering: { config: configDocument },
    title,
    creator: "Legal AI",
    styles: DocStyles,
    sections: [
      {
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [imageHeaderOne],
              }),
              new Paragraph({
                children: [imageHeaderTwo],
              }),
            ],
          }),
        },
        children: [
          new Paragraph({
            children: [image],
          }),
          breakLine(),
          docTitle("Informe de Valores"),
          breakLine(),
          docTitle(contract, 0),
          breakLine(),
          ...reportsValuesList(reports),
        ],
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.END,
                children: [new TextRun(dateFormat(new Date(), "mediumDate"))],
              }),
            ],
          }),
        },
      },
    ],
  });
  const file = Packer.toBlob(document).then((documentBlob) => documentBlob);
  return file;
};

export const reportPartsCreator = ({
  title = "Informe de partes",
  reports,
  contract = "",
}) => {
  const document = new Document({
    numbering: { config: configDocument },
    title,
    creator: "Legal AI",
    styles: DocStyles,
    sections: [
      {
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [imageHeaderOne],
              }),
              new Paragraph({
                children: [imageHeaderTwo],
              }),
            ],
          }),
        },
        children: [
          new Paragraph({
            children: [image],
          }),
          breakLine(),
          docTitle("Informe de partes"),
          breakLine(),
          docTitle(contract, 0),
          breakLine(),
          ...reportsPartsList(reports),
        ],
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                alignment: AlignmentType.END,
                children: [new TextRun(dateFormat(new Date(), "mediumDate"))],
              }),
            ],
          }),
        },
      },
    ],
  });
  const file = Packer.toBlob(document).then((documentBlob) => documentBlob);
  return file;
};

export const summaryCreator = ({ title = "Resumen de contrato", reports }) => {
  const document = new Document({
    numbering: { config: configDocument },
    title,
    creator: "Legal AI",
    styles: DocStyles,
    sections: [
      {
        properties: {},
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [imageHeaderOne],
              }),
              new Paragraph({
                children: [imageHeaderTwo],
              }),
            ],
          }),
        },
        children: [
          new Paragraph({
            children: [image],
          }),
          breakLine(),
          docTitle("Resumen de contrato"),
          breakLine(),
          breakLine(),
          docSubtitle("Objeto del contrato"),
          breakLine(),
          paragraph(
            "Cláusula donde se encuentra",
            reports?.type_object?.title || "No identificado en el documento"
          ),
          breakLine(),
          paragraphWithOutTitle(
            reports?.type_object?.text?.replace(regexDeleteHtmlTags, "") ||
              "No identificado en el documento"
          ),
          breakLine(),
          docSubtitle("Valor del contrato"),
          breakLine(),
          paragraph(
            "Cláusula donde se encuentra",
            reports?.type_clause_value?.titleClause ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraph(
            "Valor",
            reports?.type_clause_value?.value ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraph(
            "Ubicación en frase completa",
            `... ${
              reports?.type_clause_value?.keyPhrase ||
              "No identificado en el documento"
            } ...`
          ),
          breakLine(),
          docSubtitle("Término de duración"),
          breakLine(),
          paragraph(
            "Cláusula donde se encuentra",
            reports?.type_clause_milestone?.duration?.titleClause ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraph(
            "Fecha o hito",
            reports?.type_clause_milestone?.duration?.text ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraph(
            "Ubicación en frase completa",
            `... ${
              reports?.type_clause_milestone?.duration?.keyPhrase ||
              "No identificado en el documento"
            } ...`
          ),
          breakLine(),
          docSubtitle("Renovación y terminación"),
          breakLine(),
          ...reportsSummaryMilestoneTerminationList(
            reports?.type_clause_milestone?.termination || []
          ),
          breakLine(),
          docSubtitle("Ley aplicable al contrato"),
          breakLine(),
          paragraph(
            "Cláusula donde se encuentra",
            reports?.type_applicable_law?.titleClause ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraph(
            "Ley aplicable",
            reports?.type_applicable_law?.applicable_law ||
              "No identificado en el documento"
          ),
          breakLine(),
          paragraphWithOutTitle(reports?.type_applicable_law?.text),
          breakLine(),
          // ...reportsValuesList(reports)
        ],
      },
    ],
  });
  const file = Packer.toBlob(document).then((documentBlob) => documentBlob);
  return file;
};

const breakLine = () => {
  return new Paragraph({
    children: [new TextRun({ size: sizeText })],
  });
};

const textDoc = (text, size, color, bold, font) => {
  return new TextRun({ text, size, bold, color, font });
};

const docTitle = (text, textSize = 6) => {
  return new Paragraph({
    heading: HeadingLevel.TITLE,
    alignment: AlignmentType.START,
    children: [textDoc(text, sizeText + textSize, colorTitle, true, "Roboto")],
  });
};

const docSubtitle = (text, alignment = AlignmentType.START) => {
  return new Paragraph({
    heading: HeadingLevel.TITLE,
    alignment,
    children: [textDoc(text, sizeText + 2, colorTitle, true, "Roboto")],
    spacing: {
      before: 200,
    },
  });
};

const paragraph = (title, text, level = 0) => {
  return new Paragraph({
    style: "paragraphMilestone",
    children: [
      textDoc(title?.trim() + ": ", sizeText, colorBody, true),
      textDoc(text?.trim(), sizeText, colorBody, false),
    ],
    numbering: {
      reference: "decimalNumbering",
      level,
    },
  });
};

const paragraphWithOutTitle = (text, level = 0) => {
  return new Paragraph({
    style: "paragraphMilestone",
    children: [textDoc(text?.trim(), sizeText, colorBody, false)],
    numbering: {
      reference: "decimalNumbering",
      level,
    },
  });
};

const reportsList = (reports) => {
  const arrayReturn = [];

  for (const report of reports) {
    const arr = [];

    arr.push(docSubtitle(report.type));
    arr.push(breakLine());

    for (const item of report.titlesClauses) {
      arr.push(
        paragraph("Cláusula donde se encuentra", `${item?.titleClause || ""}`)
      );
      arr.push(breakLine());

      for (const milestone of item.keysPhrases) {
        const keyPhrase = milestone?.keyPhrase?.replace(
          regexDeleteHtmlTags,
          ""
        );
        arr.push(paragraph("Hitos o fechas", "", 1));
        arr.push(breakLine());

        for (const report of milestone.reports) {
          arr.push(paragraphWithOutTitle(`- ${report.text}`, 2));
          arr.push(breakLine());
        }

        arr.push(
          paragraph("Ubicación en frase completa", `... ${keyPhrase} ...`, 1)
        );
        arr.push(breakLine());
      }
    }

    arrayReturn.push(arr);
  }

  return arrayReturn.flat();
};

const reportsValuesList = (reports) => {
  const arrayReturn = [];

  for (const report of reports) {
    const arr = [];

    arr.push(docSubtitle(report.type));
    arr.push(breakLine());

    for (const item of report.titlesClauses) {
      arr.push(
        paragraph("Cláusula donde se encuentra", `${item?.titleClause || ""}`)
      );
      arr.push(breakLine());

      for (const value of item.keysPhrases) {
        const keyPhrase = value?.keyPhrase?.replace(regexDeleteHtmlTags, "");
        arr.push(paragraph("Valores", "", 1));
        arr.push(breakLine());

        for (const report of value.reports) {
          let text;
          if (["Peso", "Peso colombiano"].includes(report.currency)) {
            text = `$ ${parseFloat(report.value).toLocaleString("en-US")}`;
          } else {
            text = report.text;
          }
          arr.push(paragraphWithOutTitle(`- ${text}`, 2));

          arr.push(breakLine());
        }

        arr.push(
          paragraph("Ubicación en frase completa", `... ${keyPhrase} ...`, 1)
        );
        arr.push(breakLine());
      }
    }

    arrayReturn.push(arr);
  }

  return arrayReturn.flat();
};

const reportsPartsList = (reports) => {
  return reports
    .map((item) => {
      const namePart = item?.designation;
      const arr = [];
      arr.push(paragraph("Denominación de la parte", namePart));
      arr.push(paragraph("Identificación de la parte", item?.id_number));
      arr.push(
        paragraph(
          "Signatarios e identificación",
          item.signatories.length > 0
            ? item.signatories
                .map((sign) => `${sign?.name} (${sign?.id_number})`)
                .join(", ")
            : ""
        )
      );
      arr.push(paragraph("Domicilio", item?.address));
      arr.push(paragraph("Dirección", item?.address));
      arr.push(paragraph("Correo electrónico", item?.email));
      arr.push(paragraph("Datos de contacto", item?.tel));
      arr.push(breakLine());
      return arr;
    })
    .reduce((prev, curr) => prev.concat(curr), []);
};

const reportsSummaryMilestoneTerminationList = (reports) => {
  if (!reports?.length)
    return [paragraphWithOutTitle("No identificado en el documento")];
  return reports
    .map((item) => {
      const arr = [];
      arr.push(
        paragraph("Cláusula donde se encuentra", item?.titleClause || "")
      );
      arr.push(breakLine());
      arr.push(paragraph("Fecha o hito", item?.text || ""));
      arr.push(breakLine());
      arr.push(
        paragraph(
          "Ubicación en frase completa",
          `... ${item?.keyPhrase || ""} ...`
        )
      );
      arr.push(breakLine());
      return arr;
    })
    .reduce((prev, curr) => prev.concat(curr), []);
};

const image = new ImageRun({
  data: "data:image/jpeg;base64,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",
  transformation: {
    width: 170,
    height: 70,
  },
});

const imageHeaderOne = new ImageRun({
  data: "data:image/png;base64,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",
  transformation: {
    width: 795,
    height: 50,
  },
  floating: {
    horizontalPosition: {
      offset: 2014400,
      align: HorizontalPositionAlign.LEFT,
    },
    verticalPosition: {
      offset: 2014400,
      align: VerticalPositionAlign.TOP,
    },
    wrap: {
      type: TextWrappingType.SQUARE,
      side: TextWrappingSide.BOTH_SIDES,
    },
  },
});

const imageHeaderTwo = new ImageRun({
  data: "data:image/png;base64,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",
  transformation: {
    width: 795,
    height: 50,
  },
  floating: {
    horizontalPosition: {
      offset: 2014400,
      align: HorizontalPositionAlign.LEFT,
    },
    verticalPosition: {
      offset: 2014400,
      align: VerticalPositionAlign.TOP,
    },
    wrap: {
      type: TextWrappingType.SQUARE,
      side: TextWrappingSide.BOTH_SIDES,
    },
  },
});
